import CryptoJS from "@/utils/crypto-js.min.js";
export function restoreAesKey() {
  const part1Bytes = [107, 122, 86, 71, 80, 82];
  const part2Reversed = "bK6n8U";
  const part3Bytes = [109, 42, 82, 65, 77, 106];
  const part4Swapped = "5sUq==";
  let part1 = "";
  for (let i = 0; i < part1Bytes.length; i++) {
    part1 += String.fromCharCode(part1Bytes[i] - i);
  }
  const part2 = part2Reversed.split("").reverse().join("");
  let part3 = "";
  for (let i = 0; i < part3Bytes.length; i++) {
    part3 += String.fromCharCode(part3Bytes[i] + 1);
  }
  let part4 = "";
  for (let i = 0; i < part4Swapped.length; i++) {
    const c = part4Swapped[i];
    if (c === c.toUpperCase() && c !== c.toLowerCase()) {
      part4 += c.toLowerCase();
    } else if (c === c.toLowerCase() && c !== c.toUpperCase()) {
      part4 += c.toUpperCase();
    } else {
      part4 += c;
    }
  }
  const restoredKey = part1 + part2 + part3 + part4;
  return restoredKey;
}
export function encryptData(data) {
  try {
    const keyHex = CryptoJS.enc.Utf8.parse(restoreAesKey());
    const text = typeof data === "string" ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(text, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  } catch (e) {
    return data;
  }
}
export function decryptData(data) {
  try {
    const keyHex = CryptoJS.enc.Utf8.parse(restoreAesKey());
    const decrypted = CryptoJS.AES.decrypt(data, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const result = decrypted.toString(CryptoJS.enc.Utf8);
    try {
      return JSON.parse(result);
    } catch {
      return result;
    }
  } catch (e) {
    return data;
  }
}
export function restoreAmapKey() {
  const part1Bytes = [100, 98, 100, 58, 104, 107, 108, 105];
  const part2Reversed = "1e95a889";
  const part3Bytes = [52, 53, 50, 49, 96, 50, 47, 96];
  const part4Swapped = "CE73555B";
  let part1 = "";
  for (let i = 0; i < part1Bytes.length; i++) {
    part1 += String.fromCharCode(part1Bytes[i] - i);
  }
  const part2 = part2Reversed.split("").reverse().join("");
  let part3 = "";
  for (let i = 0; i < part3Bytes.length; i++) {
    part3 += String.fromCharCode(part3Bytes[i] + 1);
  }
  let part4 = "";
  for (let i = 0; i < part4Swapped.length; i++) {
    const c = part4Swapped[i];
    if (c === c.toUpperCase() && c !== c.toLowerCase()) {
      part4 += c.toLowerCase();
    } else if (c === c.toLowerCase() && c !== c.toUpperCase()) {
      part4 += c.toUpperCase();
    } else {
      part4 += c;
    }
  }
  const restoredKey = part1 + part2 + part3 + part4;
  return restoredKey;
}
